/**
 * @author Code Lai（赖传峰）
 * @email codelai@staritgp.com
 * @date 2020/3/3 15:32
 */
import { FEEDBACK_STATE } from 'types/enum'

export interface FeedbackInterface {
  inquireNo: string // 咨询单编码
  createTime: number // 创建时间，毫秒值
  inquireType: string // 咨询类型
  relationNo: string // 咨询单中携带的订单号，包裹号等
  content: string // 咨询内容
  reply: string // 回复内容
  updateTime: number // 最新回复时间 / 完成时间，毫秒值
  rate: boolean // 咨询单是否被评分
  state: FEEDBACK_STATE
}

export type FetchFeedbacksType = (search?: {
  pageSize?: number
  current?: number
  inquireType?: string
  startTime?: number
  endTime?: number
  isFormSubmit: boolean // 是否属于表单提交，如果属于表单提交，则不给表单 fields 赋默认值，并且重置分页
}) => void

export const enum FEEDBACK_CONSULT {
  ORDER = 'order',
  PARCEL = 'package',
  OTHERS = 'others',
}
